exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".promo-tag-counter[data-v-6295e649] {\n  position: relative;\n}\n.promo-tag-counter .count-bubble[data-v-6295e649] {\n  color: #fff;\n  height: 1.2em;\n  width: 1.2em;\n  background-color: #343434;\n  border-radius: 50%;\n  position: absolute;\n  left: 0.6em;\n  top: 0.8em;\n  line-height: initial;\n  text-align: center;\n}\n.promo-tag-counter .count-bubble.small[data-v-6295e649] {\n  height: 1em;\n  width: 1em;\n  line-height: 1em;\n  font-size: 0.9em;\n}\n", ""]);

// exports
